export const DELAY_PAYMENTS_ROUTES = [
  '/taxas-inteligentes',
  '/taxas-inteligentes/resgatar',
  '/taxas-inteligentes/resgatar/confira-os-custos',
  '/taxas-inteligentes/resgatar/informe-seu-pin',
  '/taxas-inteligentes/alterar-condicoes',
  '/taxas-inteligentes/alterar-condicoes/confira-os-dados',
  '/taxas-inteligentes/alterar-condicoes/informe-seu-pin',
  '/taxas-inteligentes/reativar-condicoes',
  '/taxas-inteligentes/reativar-condicoes/informe-seu-pin',
  '/taxas-inteligentes/quero-investir',
  '/taxas-inteligentes/quero-investir/interesse-registrado'
] as const
